export const fetchISEMappedFieldAnalysis = async (
  endpoint: string,
  accountId: string,
  vin: string,
): Promise<IISEFieldMapGetMappedFieldAnalysisResponse | null> => {
  const path = 'mapped-feed-analysis'
  const query = new URLSearchParams({
    jazelId: accountId,
    vin,
  })
  const response = await fetch(`${endpoint}/${path}?${String(query)}`, {
    method: 'GET',
  })

  if (!response.ok) {
    console.error('Error fetching mapped field analysis.')
    return null
  }

  const responseJSON = await response.json()
  console.log('#### fetchISEMappedFieldAnalysis response', responseJSON)
  return responseJSON
}
